declare global {
  type EnumList = { name: string; value: any }[];

  interface ArrayConstructor {
    fromEnum(enumeration: any): EnumList;
  }

  interface Array<T> {
    clear(): any;
    addItem(...newItem: T[]): Array<T>;
    updateItem(oldItem: T, newItem: T): Array<T>;
    patchItem(oldItem: T, values: Partial<T>): Array<T>;
    removeItem(oldItem: T): Array<T>;
    findAndUpdateItem(predicate: (value: T) => unknown, newItem: T): Array<T>;
    findAndPatchItem(
      predicate: (value: T) => unknown,
      values: Partial<T>
    ): Array<T>;
    findAndRemoveItem(predicate: (value: T) => unknown): Array<T>;
  }
}

export default function registerArrayExtensions() {
  if (!Array.fromEnum)
    Array.fromEnum = function (enumeration: any) {
      return Object.keys(enumeration)
        .filter((v) => isNaN(Number(v)))
        .map((key) => ({
          name: key.replace(/([A-Z][a-z])/g, ' $1').replace(/(\d)/g, ' $1'),
          value: enumeration[key],
        }));
    };

  if (!Array.prototype.clear)
    Array.prototype.clear = function () {
      this.splice(0);
    };

  if (!Array.prototype.addItem)
    Array.prototype.addItem = function <T>(...newItem: T[]) {
      this.unshift(...newItem);
      return [...this];
    };

  if (!Array.prototype.updateItem)
    Array.prototype.updateItem = function <T>(oldItem: T, newItem: T) {
      const index = this.indexOf(oldItem);
      this.splice(index, 1, newItem);
      return [...this];
    };

  if (!Array.prototype.patchItem)
    Array.prototype.patchItem = function <T>(oldItem: T, values: Partial<T>) {
      const index = this.indexOf(oldItem);
      this.splice(index, 1, { ...oldItem, ...values });
      return [...this];
    };

  if (!Array.prototype.removeItem)
    Array.prototype.removeItem = function <T>(oldItem: T) {
      const index = this.indexOf(oldItem);
      this.splice(index, 1);
      return [...this];
    };

  if (!Array.prototype.findAndUpdateItem)
    Array.prototype.findAndUpdateItem = function <T>(
      predicate: (value: T) => unknown,
      newItem: T
    ) {
      const item = this.find(predicate);
      if (!item) return [...this];
      return this.updateItem(item, newItem);
    };

  if (!Array.prototype.findAndPatchItem)
    Array.prototype.findAndPatchItem = function <T>(
      predicate: (value: T) => unknown,
      values: Partial<T>
    ) {
      const item = this.find(predicate);
      if (!item) return [...this];
      return this.patchItem(item, values);
    };

  if (!Array.prototype.findAndRemoveItem)
    Array.prototype.findAndRemoveItem = function <T>(
      predicate: (value: T) => unknown
    ) {
      const item = this.find(predicate);
      if (!item) return [...this];
      return this.removeItem(item);
    };
}
